
import { Component, Prop, Vue } from 'vue-property-decorator'

import BacBlueButton from '@/components/BacBlueButton.vue'
import BacButton from '@/components/BacButton.vue'

@Component({
  components: {
    BacBlueButton,
    BacButton
  }
})
export default class Waiting extends Vue {
  registerStateUrl = localStorage.getItem('registerStateLink')
  @Prop({
    default: `Dieser Bereich ist aktuell noch geschlossen...<br />
            Wir arbeiten mit Hochdruck daran ihn baldmöglichst zu öffnen, komm in Kürze noch einmal vorbei!
            <br />`
  }) closedText!: string
}
